import React, { useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { createLogOutUserAction, ILogOutUserAction } from '../actions/LogInActions';
import { LocalTokenHelper } from '../helpers/LocalTokenHelper';

export interface ILogoutBodyProps {
    logOutUser: () => ILogOutUserAction;
}

const LogOutBody: React.FC<ILogoutBodyProps> = React.memo((props: ILogoutBodyProps) => {
    // Memoize the logout function
    const handleLogout = useCallback(() => {
        // Clear the user login tokens from storage and the cache
        LocalTokenHelper.logOutUser();

        // Refresh the UI
        props.logOutUser();
    }, [props.logOutUser]);

    // Log the user out as soon as they reach the page
    useEffect(() => {
        handleLogout();
    }, [handleLogout]);

    return (
        <div className="LogOutBody">
            <label>Successfully logged out!</label>
        </div>
    );
});

const actionCreators = {
    logOutUser: createLogOutUserAction,
};

export default connect(null, actionCreators)(LogOutBody);
